<template>
  <div class="errors" v-if="hasError">
    <div class="error-message" v-for="error in errors" :key="error">{{ error }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{ error?: string | string[] }>();

const errors = computed<string[]>(() => {
  if (!props.error) {
    return [];
  }

  return Array.isArray(props.error) ? props.error : [props.error];
});

const hasError = computed(() => Boolean(errors.value.length));
</script>

<style scoped lang="scss">
.error-message {
  font: var(--t-typography-body-sm-font);
  color: var(--t-color-red-400);
}
</style>
